import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const RegisterText = styled(Typography)`
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 16px;
  font-weight: 600;
`;

export const RegisterQuestion = styled(Typography)`
  font-size: '18px';
  font-weight: 600;
  margin-bottom: 20px;
`;
